const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the email template component
 * @argument {Features} Features injected to gain access to allowed features
 */
app.directive('assignmentDynamicScheduler', ['Features', '$translate', '$sce', function (Features, $translate, $sce) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      content: '=',
      slackAvailable: '=',
      disableAssignmentOverdue: '<',
    },
    template: require('../../../templates/directives/assignments/assignment-dynamic-scheduler.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.translations = {};

      self.helptext = '';

      self.templateOptions = {};

      self.typeOptions = [
        {name: 'New Assignment', value: 'assignment_created'},
        {name: 'Reminder', value: 'assignment_reminder'},
        {name: 'Assignment Completion', value: 'assignment_passed'},
        {name: 'Assignment Failed', value: 'assignment_failed'}
      ];
      if (Features.flags().enable_overdue_notifications) {
        self.typeOptions.splice(3, 0, {name: 'Overdue Notifications', value: 'assignment_overdue'});
      }

      function createOverdueOccurrencesRange(first, last) {
        if (first >= last) {
          return;
        }
        const range = [];
        let previous = first;
        while (previous <= last) {
          range.push({name: previous.toString(), value: previous});
          previous += 1;
        }
        return range;
      }

      self.overdueCadenceOptions = [{name: 'Daily', value: 'daily'}, {name: 'Weekly', value: 'weekly'}, {name: 'Monthly', value: 'monthly'}];
      self.overdueOccurrencesOptions = createOverdueOccurrencesRange(1, 30);

      self.disabledOptions = [];

      self.channels = {
        in_app: false,
        email: false,
        slack: false
      };

      self.update = function(schedule) {

        // Handle channels
        var channels = [];
        if (!self.channels.in_app && !self.channels.email && !self.channels.slack) {
          self.channels.email = true;
        }

        if (self.channels.email) {
          channels.push('email');
        }
        if (self.channels.in_app) {
          channels.push('in_app');
        }
        if (self.channels.slack) {
          channels.push('slack');
        }

        $scope.content.channels = channels;

        // Set default email if none has been set yet
        if ($scope.content.messaging && $scope.content.messaging.email) {
          var bodyChecked;
          $scope.content.messaging.email.forEach(function(item) {
            if (item.name === 'body') {
              bodyChecked = true;
            }
          });

          if (!bodyChecked) {
            $scope.content.messaging.email.push({name: 'body', value: self.templateOptions.email[$scope.content.recipient][$scope.content.type]});
          }
        }
      };

      var getBody = function(type, item) {
        if (!item.messaging || !item.messaging[type] || !item.messaging[type].length) {
          return '';
        }
        for (var i = 0; i < item.messaging[type].length; i++) {
          if (item.messaging[type][i].name === 'body') {
            return item.messaging[type][i].value;
          }
        }
        return '';
      };

      var setBody = function(type, text) {
        if (!$scope.content.messaging || !$scope.content.messaging[type]) {
          return '';
        }
        for(var i = 0; i < $scope.content.messaging[type].length; i++) {
          if ($scope.content.messaging[type][i].name === 'body') {
            $scope.content.messaging[type][i].value = text;
            return;
          }
        }
        $scope.content.messaging[type].push({name: 'body', value: text});
      };

      self.increaseTime = function() {
        $scope.content.time_before_due = $scope.content.time_before_due + 1;
      };

      self.decreaseTime = function() {
        if (!$scope.content.time_before_due || $scope.content.time_before_due < 2) {
          $scope.content.time_before_due = 2;
        }
        $scope.content.time_before_due = $scope.content.time_before_due - 1;
      };

      self.initialize = function() {
        $scope.content.channels.forEach(function(channel) {
          self.channels[channel] = true;
        });
        if ($scope.disableAssignmentOverdue) {
          self.disabledOptions.push('assignment_overdue');
        }
        self.setWatch();
      };

      self.setWatch = function() {
        $scope.$watch('content', function(newVal, oldVal) {
          if (!newVal) {
            return;
          }
          var body = getBody('email', newVal);
          if (!body) {
            setBody('email', self.templateOptions.email[newVal.recipient][newVal.type]);
            setBody('slack', self.templateOptions.slack[newVal.recipient][newVal.type]);
            setBody('in_app', self.templateOptions.inApp[newVal.recipient][newVal.type]);
            return;
          }
  
          if (newVal.type !== oldVal.type || newVal.recipient !== oldVal.recipient) {
            var slackBody = getBody('slack', oldVal);
            var inAppBody = getBody('in_app', oldVal);
            var body = getBody('email', oldVal);
            // If the template has been changed - do not reset
            if (!oldVal.recipient || !oldVal.type || (body && body !== self.templateOptions.email[oldVal.recipient][oldVal.type])) {
              return;
            }
            // If there is no template, or its the default - set the new default
            setBody('email', self.templateOptions.email[newVal.recipient][newVal.type]);
            setBody('slack', self.templateOptions.slack[newVal.recipient][newVal.type]);
            setBody('in_app', self.templateOptions.inApp[newVal.recipient][newVal.type]);
          }
        }, true);
      };

      $translate([
        'assignmentDynamicMess.new_assignment_of_following',
        'assignmentDynamicMess.reminder_you_have_due_in',
        'assignmentDynamicMess.congrats_completed_assignment_following',
        'assignmentDynamicMess.failed_completed_assignments',
        'assignmentDynamicMess.user_has_new_assignment_following',
        'assignmentDynamicMess.user_has_due_in_days_following',
        'assignmentDynamicMess.user_has_completed_following',
        'assignmentDynamicMess.user_has_failed_following',
        'assignmentDynamicMess.you_have_new_assignment',
        'assignmentDynamicMess.reminder_assignment_due_in_days',
        'assignmentDynamicMess.congrats_completed_assignment',
        'assignmentDynamicMess.user_missed_deadline',
        'assignmentDynamicMess.user_has_new_assignment',
        'assignmentDynamicMess.user_has_due_in_days',
        'assignmentDynamicMess.user_has_completed',
        'assignmentDynamicMess.user_has_failed',
        'assignmentDynamicMess.overdue_notification_body'
      ]).then(function (translations) {
        self.translations = translations;
        self.templateOptions = {
          email: {
            assignee: {
              assignment_created: '<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {assignee_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">You have been assigned the following content:</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">Please complete these items within the next {due_in} days.</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>',
              assignment_reminder: '<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {assignee_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">Your assignment of the following content is approaching the deadline for completion:</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">Please complete these items within the next {due_in} days.</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>',
              assignment_passed: '<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {assignee_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">Congratulations! You completed your assignment of the following content:</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>',
              assignment_failed: '<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {assignee_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">Unfortunately, you were unable to complete your assignment of the following content in time.</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>',
              assignment_overdue: `<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {assignee_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">${self.translations['assignmentDynamicMess.overdue_notification_body']}</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>`
            },
            escalator: {
              assignment_created: '<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {recipient_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assignee_first_name} {assignee_last_name} has been assigned the following content:</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">These items are due within the next {due_in} days.</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>',
              assignment_reminder: '<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {recipient_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assignee_first_name} {assignee_last_name} has been assigned the following content and is approaching the deadline for completion:</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">These items are due within the next {due_in} days.</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>',
              assignment_passed: '<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {recipient_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assignee_first_name} {assignee_last_name} has completed their assignment of the following content:</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>',
              assignment_failed: '<p dir="ltr" style="font-size:10.5pt;font-family:Arial;color:#000000;">Hi {recipient_first_name},</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">Unfortunately, {assignee_first_name} {assignee_last_name} has failed to complete the following content before the deadline for completion:</p><p style="font-size:10.5pt;font-family:Arial;color:#000000;">{assigned_content}</p><br><p style="font-size:10.5pt;font-family:Arial;color:#000000;">- {assigner_first_name} {assigner_last_name}</p>'
            }
          },
          slack: {
            assignee: {
              assignment_created: $sce.valueOf(self.translations['assignmentDynamicMess.new_assignment_of_following']),
              assignment_reminder: $sce.valueOf(self.translations['assignmentDynamicMess.reminder_you_have_due_in']),
              assignment_passed: $sce.valueOf(self.translations['assignmentDynamicMess.congrats_completed_assignment_following']),
              assignment_failed: $sce.valueOf(self.translations['assignmentDynamicMess.failed_completed_assignments']),
              assignment_overdue: $sce.valueOf(self.translations['assignmentDynamicMess.overdue_notification_body']),
            },
            escalator: {
              assignment_created: $sce.valueOf(self.translations['assignmentDynamicMess.user_has_new_assignment_following']),
              assignment_reminder: $sce.valueOf(self.translations['assignmentDynamicMess.user_has_due_in_days_following']),
              assignment_passed: $sce.valueOf(self.translations['assignmentDynamicMess.user_has_completed_following']),
              assignment_failed: $sce.valueOf(self.translations['assignmentDynamicMess.user_has_failed_following'])
            }
          },
          inApp: {
            assignee: {
              assignment_created: $sce.valueOf(self.translations['assignmentDynamicMess.you_have_new_assignment']),
              assignment_reminder: $sce.valueOf(self.translations['assignmentDynamicMess.reminder_assignment_due_in_days']),
              assignment_passed: $sce.valueOf(self.translations['assignmentDynamicMess.congrats_completed_assignment']),
              assignment_failed: $sce.valueOf(self.translations['assignmentDynamicMess.user_missed_deadline']),
              assignment_overdue: $sce.valueOf(self.translations['assignmentDynamicMess.overdue_notification_body']),
            },
            escalator: {
              assignment_created: $sce.valueOf(self.translations['assignmentDynamicMess.user_has_new_assignment']),
              assignment_reminder: $sce.valueOf(self.translations['assignmentDynamicMess.user_has_due_in_days']),
              assignment_passed: $sce.valueOf(self.translations['assignmentDynamicMess.user_has_completed']),
              assignment_failed: $sce.valueOf(self.translations['assignmentDynamicMess.user_has_failed'])
            }
          }
        };

        self.initialize();

      });

    }],
    controllerAs: 'schedule'
  };
}]);